import { render, staticRenderFns } from "./Grafica5.vue?vue&type=template&id=23ab8c4a&"
import script from "./Grafica5.vue?vue&type=script&lang=js&"
export * from "./Grafica5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports